module.exports = {
  type: 'spa',
  isTenanted: true,
  publicPath: '/nz-landing/',
  octopusPackageId: 'nz-landing',
  octopusProjectName: 'NZ Landing',
  mountDOMId: 'app',
  standalone: true
};